import { useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import ModalPopup from "../ModalPopup";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";
import UECard from "../UECard";

const MAX_SMS_ATTEMPT = 3;

function Riepilogo() {
    var localData = localStorage.getItem('SWINS-State');
    let C = JSON.parse(localData);//StepContext.contratto

    let descrizione = '';
    if ((C.nome !== undefined) && (C.nome.trim().length > 0))
        descrizione += C.nome;
    if ((C.cognome !== undefined) && (C.cognome.trim().length > 0))
        descrizione += ' ' + C.cognome;
    if ((C.ragsoc !== undefined) && (C.ragsoc.trim().length > 0))
        descrizione = C.ragsoc;

    let dati_fiscali = ''
    if ((C.cofi !== undefined) && (C.cofi.trim().length > 0))
        dati_fiscali += ' codice fiscale: ' + C.cofi;
    if ((C.piva !== undefined) && (C.piva.trim().length > 0))
        dati_fiscali += ' P.IVA: ' + C.piva;

    let ubicazione = C.uf_descrizione_comune + ', ';
    ubicazione += C.uf_toponimo + ' ' + C.uf_via + ' ' + C.uf_civico;
    if ((C.uf_suffisso !== undefined) && (C.uf_suffisso.trim().length > 0))
        ubicazione += ' ' + C.uf_suffisso;

    let riepilogo_EE = '';
    if ((C.offertaEE !== undefined) && (C.offertaEE !== ""))
        riepilogo_EE = (<p>Stiamo attivando l'offerta: <b>{C.offertaEE_desc}</b> per il POD: <b>{C.pod}</b>, intestato a: <b>{descrizione}</b> con <b>{dati_fiscali} </b>
            indirizzo mail <b>{C.mail}</b>, telefono: <b>{C.mobile}</b>, all'indirizzo: <b>{ubicazione}</b></p>);

    let riepilogo_GAS = '';
    if ((C.offertaGAS !== undefined) && (C.offertaGAS !== ""))
        riepilogo_GAS = (<p>Stiamo attivando l'Offerta <b>{C.offertaGAS_desc}</b> per il PDR <b>{C.pdr}</b>, intestato a <b>{descrizione}</b> con <b>{dati_fiscali} </b>
            indirizzo mail <b>{C.mail}</b>, telefono <b>{C.mobile}</b>, all'indirizzo <b>{ubicazione}</b></p>);

    let riepilogo_dati_catastali = '';
    if ((C.codiceCatastale !== undefined) && (C.codiceCatastale.trim().length > 0))
        riepilogo_dati_catastali += 'Codice Comune: ' + C.codiceCatastale;
    if ((C.foglio !== undefined) && (C.foglio.trim().length > 0))
        riepilogo_dati_catastali += ' Foglio: ' + C.foglio;
    if ((C.particella !== undefined) && (C.particella.trim().length > 0))
        riepilogo_dati_catastali += ' Particella: ' + C.particella;
    if ((C.sezione !== undefined) && (C.sezione.trim().length > 0))
        riepilogo_dati_catastali += ' Sezione: ' + C.sezione;
    if ((C.subalterno !== undefined) && (C.subalterno.trim().length > 0))
        riepilogo_dati_catastali += ' Subalterno: ' + C.subalterno;
    if ((C.categoria !== undefined) && (C.categoria.trim().length > 0))
        riepilogo_dati_catastali += ' Categoria: ' + C.categoria;

    if (riepilogo_dati_catastali.trim().length === 0) {
        riepilogo_dati_catastali = <span style={{ background: "red", color: "white", padding: "5px", borderRadius: "10px", display: "block" }}><b>Non ci hai comunicato i dati catastali! Ricorda di inserirli al più presto dall'area clienti <a href="#">MyUmbriaEnergy</a> o nell'app per <a href="#">Android</a> e <a href="#">iOS</a></b></span>;
    }

    let riepilogo_mod_pagam = '';
    if (C.modPagamento === "D") {
        riepilogo_mod_pagam = (<p>La modalità di pagamento scelta è la <b>Domiciliazione Bancaria</b> su conto IBAN <b>{C.dd_IBAN}</b></p>);
    } else {
        riepilogo_mod_pagam = (<p>La modalità di pagamento scelta è il <b>Bollettino PagoPa</b></p>);
    }

    let riepilogo_invio_fat = '';
    if (C.tipoIn == "0") {
        riepilogo_invio_fat = (<p>Hai scelto di ricevere le fatture all'indirizzo e-mail <b>{C.tp_mail}</b></p>);
    } else {
        riepilogo_invio_fat = (<p>Hai scelto di ricevere le fatture in formato <b>cartaceo</b> per posta</p>);
    }

    return <>{riepilogo_EE} {riepilogo_GAS} {riepilogo_mod_pagam} {riepilogo_invio_fat} <p>{riepilogo_dati_catastali}</p></>
}

var msgText = '';
var msgTitle = '';

function StepConferma() {

    const { step, setStep } = useContext(StepContext);
    const [mobile, setMobile] = useState(readCurrentState("mobile"));
    const [otp, setOTP] = useState("");
    const [otpAttempt, setOTPAttempt] = useState(0);

    const [modalShow, setModalShow] = useState(false);

    const [invioContratto, setInvioContratto] = useState(false);
    const [invioSMS, setInvioSMS] = useState(false);

    function sendOTP() {

        setInvioSMS(true);

        let conx = {
            step: step,
        };
        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();

        fetch(process.env.REACT_APP_API_URL + 'contratti/' + StepContext.contratto.uid)
            .then(response => {
                setInvioSMS(false);
                if (response.ok) {
                    //  console.log(response);
                    return response.text()
                } else {
                    msgText = "Non è stato possibile inviare l'SMS di verifica controlla il numero inserito o contatta l'assistenza clienti per completare il contratto.";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                }
            }
            )
            .then(data => {
                setInvioSMS(false);
                //console.log("Send response: " + data);
                if (data !== "OK") {
                    msgText = "Non è stato possibile inviare l'SMS di verifica controlla il numero inserito o contatta l'assistenza clienti per completare il contratto.";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                    return;
                }
                let otpa = otpAttempt;
                otpa++
                setOTPAttempt(otpa);
                updateSendButtonClass();
                //console.log(otpAttempt);
            }
            ).catch(
                (error) => {
                    setInvioContratto(false);
                    msgText = "Non è stato possibile inviare il codice di verifica,riprova tra poco o contatta l'assistenza clienti per completare la pratica.";
                    msgTitle = 'Verifica non completata';
                    setModalShow(true);
                }
            )
    }

    function updateSendButtonClass() {
        if (otpAttempt <= 0) {
            return "btn-blue"
        } else if ((otpAttempt > 0) && (otpAttempt < MAX_SMS_ATTEMPT)) {
            return "btn-green"
        } else {
            return "btn-yellow"
        }
    }
    function updateSendButtonDisabled() {
        return (otpAttempt > MAX_SMS_ATTEMPT);
    }
    function AttemptText() {
        if ((otpAttempt > 0) && (otpAttempt <= MAX_SMS_ATTEMPT))
            return <p style={{ background: "green", color: "white", padding: "5px", borderRadius: "10px", display: "block", marginTop: "10px" }}>SMS inviato, verifica il tuo dispositivo.</p>;
        if (otpAttempt > MAX_SMS_ATTEMPT)
            return <p style={{ background: "red", color: "white", padding: "5px", borderRadius: "10px", display: "block", marginTop: "10px" }}>E' stato superato il numero massimo di tentativi di invio dell'SMS di verifica, contatta il servizio Clienti per completare la pratica.</p>;
    }

    function verifyOTP() {
        var V = { "uid": StepContext.contratto.uid, "otp": otp };
        setInvioContratto(true);
        fetch(process.env.REACT_APP_API_URL + 'contratti/verify',
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(V)
            })
            .then(response => {
                setInvioContratto(false);
                if (response.ok) {
                    return response.json()
                } else {
                    msgText = "Non è stato possibile verificare il contratto e completare la procedura,contatta l'assistenza clienti per completare la pratica.";
                    msgTitle = 'Verifica non completata';
                    setModalShow(true);
                }
            }
            )
            .then(data => {
                setInvioContratto(false);
                if ((data.message == undefined)) {
                    msgText = "Non è stato possibile verificare il contratto,contatta l'assistenza clienti per completare la pratica.";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                } else
                    if ((data.message !== "OK")) {
                        msgText = "Il codice di verifica non è valido riprova o contatta l'assistenza clienti per completare il contratto.";
                        msgTitle = 'Informazioni non valide o mancanti';
                        setModalShow(true);
                    } else
                        if (data.message === "OK") {
                            //msgText = "Grazie, il contratto "+data.pda+" è stato inviato all'indirizzo e-mail da te indicato, completa i passaggi per attivare la fornitura.";
                            //msgTitle = 'Contratto inviato!';
                            //setModalShow(true);

                            //Vai a step 100 per confera e ringraziamenti                
                            setStep(100);
                        }
            }
            ).catch(
                (error) => {
                    console.error(error);
                    setInvioContratto(false);
                    msgText = "Non è stato possibile verificare il contratto e completare la procedura,riprova tra poco o contatta l'assistenza clienti per completare la pratica.";
                    msgTitle = 'Verifica non completata';
                    setModalShow(true);
                }
            )
    }


    function SpinnerInvioContratto() {
        if (invioContratto) {
            return <><Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                variant="warning"
            /> Invio del contratto</>
        } else {
            return <>VERIFICA E COMPLETA</>;
        }
    }
    function SpinnerInvioSMS() {
        if (invioSMS) {
            return <><Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                variant="warning"
            /> Invio in corso</>
        } else {
            return <>INVIA SMS ORA</>;
        }
    }

    return <>
        <UECard BackButton={true} NextButton={false} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} >
            <h2 style={{ color: "green" }}><b>Ci siamo! Un ultimo controllo ai dati per diventare cliente di<br />Umbria Energy</b></h2>
            <h3 style={{ textAlign: "center" }}>I dati che hai inserito:</h3>
            <br />
            <div style={{ textAlign: "center" }}>
                <Riepilogo />
                <hr />
                <h2 style={{ color: "green" }}>Conferma contratto</h2>

                <h3>Per confermare il contratto ti invieremo un SMS con un codice di 6 cifre al numero di telefono <span style={{ color: "green" }}><b>{mobile}</b></span> da te indicato.</h3>
                <br />
                <button className={"ue btn " + updateSendButtonClass()} disabled={updateSendButtonDisabled()} onClick={sendOTP}>{SpinnerInvioSMS()}</button>
                {AttemptText()}
                <br />
                <br />
                <h3>SMS Inviato! Inserisci qui il codice che hai ricevuto sul tuo telefono</h3>
                <br />
                <input type="text" className="ue ue-text"
                    style={{ height: "45px", marginTop: "5px !mportant", textAlign: "center" }}
                    id="otp" placeholder="Inserisci il codice che hai ricevuto"
                    maxLength="6" value={otp} onChange={(e) => { setOTP(e.target.value) }} />
                <button className='ue btn btn-green' onClick={verifyOTP} disabled={invioContratto}>{SpinnerInvioContratto()}</button>
                <br />
                <small>Se non hai ricevuto l'SMS verifica che il tuo numero sia corretto.</small>
                <br />
                <small>Se lo devi modificare clicca PRECEDENTE, altrimenti premi nuovamente su INVIA SMS ORA.</small>
            </div>
        </UECard>
        <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />
    </>

}

export default StepConferma;